import React from 'react'
import {Box, Card, CardContent, CardMedia, Typography} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { demoProfilePicture } from '../utils/constants';

const ChannelCard = ({channelDetail, marginTop}) => {
  return (
    <Box
        sx={{
            boxShadow: 'none',
            borderRadius: '20px',
            display: 'flex',
            flexDirection: 'column', 
            transition: '0.3s all',
            justifyContent: 'center',
            width: {xs: '356px', md: '258px'},
            height: 'auto',
            margin: 'auto',
            marginTop: marginTop
        }}
    >
        <Card sx={{display:'flex', flexDirection: 'column'}}>
          <CardMedia
            component="img"
            src={channelDetail?.snippet?.thumbnails?.medium?.url || demoProfilePicture}
          />
          <CardContent>
            <Typography variant="h6" >
              {channelDetail?.snippet?.title}
              <CheckCircleIcon sx={{ fontSize: '14px', color: 'gray', ml: '5px' }} />
            </Typography>
            <Typography variant="subtitle2">
              {parseInt(channelDetail?.statistics?.subscriberCount).toLocaleString()} subscribers
            </Typography>
          </CardContent>
        </Card>
    </Box>
  )
}

export default ChannelCard